<block-ui>
    <form class="row mb-3" [formGroup]="SearchForm">
        <div class="col">
            <label class="">Nombre:</label>
            <input type="text" class="form-control form-control-sm" formControlName="Name" (change)="LoadTemplateDocumentsPagedCount()">
        </div>
        <div class="col">
            <label class="">Creador:</label>
            <input type="text" class="form-control form-control-sm" formControlName="CreateUser" (change)="LoadTemplateDocumentsPagedCount()">
        </div>
        <div class="col">
            <label class="">Editor:</label>
            <input type="text" class="form-control form-control-sm" formControlName="UpdateUser" (change)="LoadTemplateDocumentsPagedCount()">
        </div>
        <div class="col">
            <label class="">Actualización desde:</label>
            <input type="date" class="form-control form-control-sm" formControlName="From" (change)="ValidateDate('From')" (blur)="(search)?LoadTemplateDocumentsPagedCount():false">
        </div>
        <div class="col">
            <label class="">Actualización hasta:</label>
            <input type="date" class="form-control form-control-sm" formControlName="To" (change)="ValidateDate('To')" (blur)="(search)?LoadTemplateDocumentsPagedCount():false">
        </div>
        <div class="col">
            <label class="">Formato:</label>
            <select class="form-control form-control-sm" id="template_types" formControlName="TemplateType" (change)="LoadTemplateDocumentsPagedCount()">
                <option value="">Todos</option>
                <option *ngFor="let TemplateType of TemplateTypes" [value]="TemplateType.Id">{{TemplateType.Name}}</option>
            </select>
        </div>
        <div class="d-flex align-items-end mr-3">
            <div class="d-flex flex-row-reverse">
                <button type="button" class="btn btn-light shadow-sm btn-sm" (click)="LoadTemplateDocumentsPagedCount()">Buscar</button>
            </div>
        </div>
    </form>
    <div class="tableFixHead">
        <table class="table table-striped table-sm">
            <thead style="background-color: #172749; color: white;">
                <tr>
                    <th scope="col" style="position: sticky; top: 0;">#</th>
                    <th scope="col" style="position: sticky; top: 0;">Nombre</th>
                    <th scope="col" style="position: sticky; top: 0;">Formato</th>
                    <th scope="col" style="position: sticky; top: 0;">Creador</th>
                    <th scope="col" style="position: sticky; top: 0;">Fecha creación</th>
                    <th scope="col" style="position: sticky; top: 0;">Editor</th>
                    <th scope="col" style="position: sticky; top: 0;">Fecha edición</th>
                    <th scope="col" style="position: sticky; top: 0;">Opciones</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let TemplateDocument of TemplateDocuments; let i = index" class="p-0">
                    <td scope="row">{{(i + 1 + ((CurrentPage-1)*PageSize))}}</td>
                    <td>{{GetTemplateName(TemplateDocument)}}</td>
                    <td>{{TemplateDocument.Template.TemplateType.Name}} - {{TemplateDocument.DocumentType.Name}}</td>
                    <td>{{TemplateDocument.CreateUser.Email}}</td>
                    <td>{{TemplateDocument.CreateDate | date: 'dd/MM/yyyy' }}</td>
                    <td>{{TemplateDocument.UpdateUser.Email}}</td>
                    <td>{{TemplateDocument.UpdateDate | date: 'dd/MM/yyyy' }}</td>
                    <td>
                        <a class="btn btn-sm btm-primary" [routerLink]="['/legal-templates', TemplateDocument.Template.TemplateTypeId, TemplateDocument.TemplateId]">
                            <fa-icon class="fa" icon="edit"></fa-icon>
                        </a>
                        <button type="button" class="btn btn-sm btm-primary" (click)="Download(TemplateDocument)">
                            <fa-icon class="fa" icon="print"></fa-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="row">
        <ngb-pagination class="col d-flex justify-content-center mt-2" [collectionSize]="CollectionSize" [pageSize]="PageSize" [(page)]="CurrentPage" [boundaryLinks]="true" (pageChange)="LoadTemplateDocuments()">
            <ng-template ngbPaginationPages let-page let-pages="pages">
                <li class="ngb-custom-pages-item" *ngIf="pages.length > 0">
                    <div class="form-group d-flex flex-nowrap px-2">
                        <label id="paginationInputLabel" for="paginationInput" class="col-form-label mr-2 ml-1">Página</label>
                        <input #i type="text" inputmode="numeric" pattern="[0-9]*" class="form-control custom-pages-input" id="paginationInput" [value]="CurrentPage" (keyup.enter)="SelectPage(i.value)" (blur)="SelectPage(i.value)" (change)="LoadTemplateDocuments()" (input)="FormatInput($any($event).target)"
                            aria-labelledby="paginationInputLabel paginationDescription" />
                        <span id="paginationDescription" class="col-form-label text-nowrap px-2">
                          de {{pages.length}}</span>
                    </div>
                </li>
            </ng-template>
        </ngb-pagination>
    </div>
</block-ui>